var formError = {
    commentFail: 'Hubo un problema al enviar sus comentarios. Por favor inténtelo de nuevo más tarde o utilice nuestro Chat en Línea para obtener ayuda.',
    partialError: '',
    pleaseSelect: 'Por favor, seleccione una opción para continuar.',
    pleaseAnswer: 'Se requiere una respuesta para continuar.',
    pleaseSelectDate: 'Por favor, seleccione una fecha para continuar.',
    invalidAmount: 'El monto no puede ser mayor que el precio de compra.',
    amountMustBe: 'La cantidad debe ser mayor que 0',
    charactersOverLimit: '{{charsOverLimit}} caracteres por encima del límite',
    oneCharacterOverLimit: '1 caracter por encima del límite',
    tooManyCharacters: 'Lo sentimos, ha alcanzado el máximo de 1,000 caracteres.',
    moreThanHundredCharacters: 'Lo sentimos, ha alcanzado el máximo de 100 caracteres.',
    required: 'Este campo es obligatorio y no se puede dejar vacío.',
    unsupportedFileType: 'Tipo de archivo no soportado. Vuelva a intentarlo con uno de los tipos de archivo admitidos: PNG, JPG o PDF.',
    maximumFileSize: "El archivo adjunto supera el tama\u00F1o m\u00E1ximo de {{maxFileSize}}. Reduzca el tama\u00F1o total del archivo y vuelva a intentarlo.",
    cancelReason: 'Por favor ingrese el motivo de la cancelación.',
    cancelReasonPlaceholder: 'Ingrese el motivo de la cancelación',
    pleaseSelectAdditionalTransactions: 'Por favor, seleccione transacciones adicionales de este comerciante para disputarlas'
};
export default formError;
//# sourceMappingURL=formError.js.map